import { useFormikContext } from 'formik';
import get from 'lodash/get';
import React from 'react';

import { DefaultItemProps, Select } from '@candu-ai/analytics/ui';
import { DefinitionDatePicker, TimeframeInput } from 'dashboard/pages/Segment/components/DefinitionFormFields';
import { SelectInputWrapper } from 'dashboard/pages/Segment/components/DefinitionFormFields/DefinitionFormComponents';
import { segmentUserSeenOptions } from 'dashboard/pages/Segment/components/constants';
import { DefinitionFormikValues } from 'dashboard/pages/Segment/components/types';

interface DateOperandProps {
  base: string;
  readOnly?: boolean;
  isAbsoluteDate: boolean;
}

export const DateOperand = ({ base, readOnly, isAbsoluteDate }: DateOperandProps) => {
  return isAbsoluteDate ? (
    <DefinitionDatePicker name={`${base}.UserSeen.operation.operandDate`} readOnly={readOnly} />
  ) : (
    <TimeframeInput name={`${base}.UserSeen.operation.operand`} readOnly={readOnly} />
  );
};

export interface UserSeenRuleProps {
  base: string;
  readOnly?: boolean;
}

export const UserSeenRule = ({ base, readOnly }: UserSeenRuleProps) => {
  const { values, setFieldValue } = useFormikContext<DefinitionFormikValues>();

  const operationTypePath = `${base}.UserSeen.operation.type`;

  const dateOperationType = get(values, operationTypePath, null);
  const isAbsoluteDate = dateOperationType && dateOperationType.includes('absolute');

  return (
    <React.Fragment>
      <Select<DefaultItemProps, DefinitionFormikValues>
        name={operationTypePath}
        readOnly={readOnly}
        options={segmentUserSeenOptions}
        placeholder="Choose operator"
        InputWrapper={SelectInputWrapper}
        data-cy="segment-definition-selector"
        values={values}
        setFieldValue={setFieldValue}
        validateOnSelectWithErrors
      />
      {dateOperationType && (
        <DateOperand base={base} readOnly={readOnly} isAbsoluteDate={isAbsoluteDate} />
      )}
    </React.Fragment>
  );
};
